import { RecordComparer } from '../../types';
import { RecordType } from '@petconsole/pure-shared';

const compareCreatedAt: (ascending: boolean) => RecordComparer =
  (ascending = true) =>
  ({ createdAt: a }: RecordType, { createdAt: b }: RecordType) =>
    ascending ? (a as string).localeCompare(b as string) : (b as string).localeCompare(a as string);

export default compareCreatedAt;
